import { cn } from '@virginexperiencedays/tailwind';
import type { BlogPostPageType } from '@virginexperiencedays/cms';

import { DisplayHeading } from '../../../typography/DisplayHeading';
import { BlogPostCard } from '../../../cards/BlogPostCard';
import { Grid } from '../../../layout/Grid';

export type RelatedPostsProps = {
  posts: BlogPostPageType[];
  title: string;
  className?: string;
};

export const RelatedPosts = ({ className, posts, title }: RelatedPostsProps) => {
  if (posts?.length < 1) {
    return null;
  }

  return (
    <div className="justify-center sm:text-center">
      <DisplayHeading
        className="text-neutral-strong my-6"
        size="3"
        as="h2"
        data-testid={'related-posts-title'}
      >
        {title}
      </DisplayHeading>
      <Grid
        data-testid="related-posts"
        className={cn('text-left sm:justify-center', className)}
        space="lg"
        spaceY="xl"
        columns={{
          mobile: 1,
          largeMobile: 2,
          desktop: 3,
        }}
      >
        {posts.slice(0, 3).map((post, index) => {
          return <BlogPostCard key={index} post={post} href={post._meta?.uid} />;
        })}
      </Grid>
    </div>
  );
};
